import { State } from "../types";

export function saveRule(state: State, payload: null): State {
  if (!state.canSave) return state;
  // Un nuevo intento descarta el error del anterior
  return { ...state, asyncStatus: "saving", saveError: undefined };
}

export type SaveRule = {
  type: "saveRule";
  payload?: null;
};
